export const PAGE_CATEGORIES = [
  { id: 'all', nameUrdu: 'تمام پیجز' },
  { id: 'general', nameUrdu: 'عمومی پیجز' },
  { id: 'policy', nameUrdu: 'پالیسی پیجز' },
  { id: 'system', nameUrdu: 'سسٹم پیجز' }
];

export const INITIAL_PAGES = [
  {
    id: 'page-home',
    slug: '/',
    titleUrdu: 'ہوم پیج / صفحہ اول',
    titleEn: 'Home Page',
    title: 'Home Page',
    category: 'system',
    categoryUrdu: 'سسٹم پیجز',
    contentHtml: '<p>یہ ہوم پیج ہے۔ اس کا ڈیزائن اور مواد ڈیش بورڈ کے (CMS / سٹور سیٹنگز) حصے سے تبدیل ہوتا ہے۔</p>',
    content: 'یہ ہوم پیج ہے۔ اس کا ڈیزائن اور مواد ڈیش بورڈ کے (CMS / سٹور سیٹنگز) حصے سے تبدیل ہوتا ہے۔',
    publishedDate: '2026-10-05',
    status: 'published'
  },
  {
    id: 'page-shop',
    slug: 'shop',
    titleUrdu: 'سٹور / تمام ادویات',
    titleEn: 'Shop',
    title: 'Shop',
    category: 'system',
    categoryUrdu: 'سسٹم پیجز',
    contentHtml: '<p>یہ سٹور کا مین پیج ہے۔</p>',
    content: 'یہ سٹور کا مین پیج ہے۔',
    publishedDate: '2026-10-05',
    status: 'published'
  },
  {
    id: 'page-categories',
    slug: 'categories',
    titleUrdu: 'اقسام ادویات',
    titleEn: 'Categories',
    title: 'Categories',
    category: 'system',
    categoryUrdu: 'سسٹم پیجز',
    contentHtml: '<p>یہ کیٹیگریز کا پیج ہے۔ اس میں موجود ادویات کی اقسام آپ کیٹگری مینیجر سے کنٹرول کر سکتے ہیں۔</p>',
    content: 'یہ کیٹیگریز کا پیج ہے۔ اس میں موجود ادویات کی اقسام آپ کیٹگری مینیجر سے کنٹرول کر سکتے ہیں۔',
    publishedDate: '2026-10-05',
    status: 'published'
  },
  {
    id: 'page-blogs',
    slug: 'blogs',
    titleUrdu: 'بلاگ و مقالات',
    titleEn: 'Blogs',
    title: 'Blogs',
    category: 'system',
    categoryUrdu: 'سسٹم پیجز',
    contentHtml: '<p>یہ بلاگز کا مین پیج ہے۔ تمام بلاگز خودکار طریقے سے یہاں شو ہوتے ہیں۔</p>',
    content: 'یہ بلاگز کا مین پیج ہے۔ تمام بلاگز خودکار طریقے سے یہاں شو ہوتے ہیں۔',
    publishedDate: '2026-10-05',
    status: 'published'
  },
  {
    id: 'page-tibbi-guide',
    slug: 'tibbi-guide',
    titleUrdu: 'طبی رہنمائی و مزاج',
    titleEn: 'Tibbi Guide',
    title: 'Tibbi Guide',
    category: 'system',
    categoryUrdu: 'سسٹم پیجز',
    contentHtml: '<p>یہ طبی رہنمائی کا پیج ہے۔ اس کے اندر موجود تمام معلومات ڈیش بورڈ میں <strong>سٹور سیٹنگز / CMS</strong> کے ٹیب میں موجود <strong>"حکیم صاحب / طبی معلومات"</strong> کے سیکشن سے ایڈٹ کی جا سکتی ہیں۔</p>',
    content: 'یہ طبی رہنمائی کا پیج ہے۔ اس کے اندر موجود تمام معلومات ڈیش بورڈ میں سٹور سیٹنگز / CMS کے ٹیب میں موجود حکیم صاحب / طبی معلومات کے سیکشن سے ایڈٹ کی جا سکتی ہیں۔',
    publishedDate: '2026-10-05',
    status: 'published'
  },
  {
    id: 'page-about',
    slug: 'about-hakim',
    titleUrdu: 'ہمارے بارے میں',
    titleEn: 'About Us',
    title: 'About Us',
    category: 'system',
    categoryUrdu: 'سسٹم پیجز',
    contentHtml: '<p>یہ حکیم صاحب اور دواخانے کے تعارف کا پیج ہے۔ اسے ڈیش بورڈ میں <strong>سٹور سیٹنگز / CMS</strong> کے ٹیب میں جا کر <strong>"حکیم صاحب / تعارف"</strong> کے حصے سے تبدیل کیا جا سکتا ہے۔</p>',
    content: 'یہ حکیم صاحب اور دواخانے کے تعارف کا پیج ہے۔ اسے ڈیش بورڈ میں سٹور سیٹنگز / CMS کے ٹیب میں جا کر تبدیل کیا جا سکتا ہے۔',
    publishedDate: '2026-10-05',
    status: 'published'
  },
  {
    id: 'page-contact',
    slug: 'contact',
    titleUrdu: 'رابطہ و مطب',
    titleEn: 'Contact Us',
    title: 'Contact Us',
    category: 'system',
    categoryUrdu: 'سسٹم پیجز',
    contentHtml: '<p>یہ رابطے کا پیج ہے۔ اس کی تفصیلات (فون نمبر، واٹس ایپ، پتہ) ڈیش بورڈ میں <strong>سٹور سیٹنگز / CMS</strong> کے مین سیکشن سے ایڈٹ کی جا سکتی ہیں۔</p>',
    content: 'یہ رابطے کا پیج ہے۔ اس کی تفصیلات ڈیش بورڈ میں سٹور سیٹنگز سے ایڈٹ کی جا سکتی ہیں۔',
    publishedDate: '2026-10-05',
    status: 'published'
  },
  {
    id: 'page-privacy-policy',
    slug: 'privacy-policy',
    titleUrdu: 'پرائیویسی پالیسی',
    titleEn: 'Privacy Policy',
    title: 'Privacy Policy',
    category: 'policy',
    categoryUrdu: 'پالیسی پیجز',
    contentHtml: '<h2>پرائیویسی پالیسی</h2><p>یہ پرائیویسی پالیسی کا نمونہ ہے۔ آپ اسے ایڈٹ کر کے اپنی پالیسی لکھ سکتے ہیں۔</p>',
    content: 'پرائیویسی پالیسی کا نمونہ',
    publishedDate: '2026-10-05',
    status: 'published'
  }
];
